// extracted by mini-css-extract-plugin
export default {"container":"HeaderOnly_container__1Ns3L"};